import type React from 'react';
import { useEffect } from 'react';
import { useIntl } from 'react-intl';

import { Breadcrumbs } from '../../components/breadcrumbs/breadcrumbs';
import { MetaData } from '../../components/meta-data';
import { SectionCompaniesByIndustries } from '../../components/section-companies-by-industry/section-companies-by-industry';
import { SectionCompaniesInsights } from '../../components/section-companies-insights/section-companies-insights';
import { usePagination } from '../../hooks/use-pagination';
import { useTrackPage } from '../../hooks/use-track-page';
import {
  pagesTrackingName,
  useNwtTrackingCompanies,
} from '../../utils/tracking';
import * as Styled from './logged-out-landing-page.style';
import { BestCompaniesByCity } from './sections/best-companies-by-city/best-companies-by-city';
import { MostVisitedCompaniesSection } from './sections/most-visited-companies/most-visited-companies-section';
import { TopCompaniesSection } from './sections/top-companies/top-companies-section';

export const LoggedOutLandingPage: React.FC = () => {
  const { formatMessage } = useIntl();
  const trackNwtEvent = useNwtTrackingCompanies();
  const { activePage, isFirstPage } = usePagination();
  const currentUrl = global.location;

  useTrackPage({ pageName: pagesTrackingName.loggedOutLanding });

  useEffect(() => {
    trackNwtEvent({
      eventSchema: 'basic',
      page: 'companies/overview',
      event: 'viewed_screen',
    });
  }, []);

  return (
    <>
      <MetaData
        index={isFirstPage}
        title={formatMessage({ id: 'CP_LO_INDUSTRY_COMPANIES_META_TITLE' })}
        description={formatMessage({
          id: 'CP_LO_INDUSTRY_COMPANIES_META_DESCRIPTION',
        })}
        canonicalUrl={activePage ? currentUrl : undefined}
      />

      <Styled.LoggedOutContainer data-testid="LOGGED-OUT-LANDING-PAGE">
        <Styled.HightlightSection>
          <Styled.CenterContainer>
            <Styled.BreadcrumbsContainer>
              <Breadcrumbs />
            </Styled.BreadcrumbsContainer>
            <TopCompaniesSection />
          </Styled.CenterContainer>
        </Styled.HightlightSection>

        <Styled.BottomContent>
          <SectionCompaniesInsights />
          <MostVisitedCompaniesSection />
          <SectionCompaniesByIndustries />
          <BestCompaniesByCity />
        </Styled.BottomContent>
      </Styled.LoggedOutContainer>
    </>
  );
};
